import Validator from 'arbitrip-common/client/utils/Validator';
import { email_regex } from 'arbitrip-common/general/constants/regexes';

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { withTranslation } from 'react-i18next';

import Events from '../../../events/Events';
import Constants from '../../../events/constants/ReservationPaymentPage';

import SearchStore from '../../../stores/SearchStore';
import ProfileStore from '../../../stores/ProfileStore';
import PointsStore from '../../../stores/PointsStore';
import User from '../../../entities/User';

import ReservationActions from '../../../actions/ReservationActions';
import ReservationConstants from '../../../constants/ReservationConstants';
import Analytics from 'arbitrip-common/client/analytics/actions/interactions';
import Ajax from '../../../utils/Ajax';

import TravelersHelper from './helpers/TravelersHelper';

import TravelersAutocomplete from './components/TravelersAutocomplete.react';

import Config from 'arbitrip-common/client/utils/Config';

import { TextField, Avatar, IconButton, Button, CircularProgress } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { avatarProps } from '../../../utils/AvatarUtils';
import { ArbiCancelButton } from '@/components/general/styled/buttons';
import { MuiTelInput } from 'mui-tel-input';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SyncIcon from '@mui/icons-material/Sync';
import { LTR } from 'arbitrip-common/translation/const';
import PointsAndDiamondsBanner from './components/PointsAndDiamondsBanner';
import { SUPPORTED_LANGUAGES, RTL } from 'arbitrip-common/translation/const';
const { SAVE_TRAVELER_CARD } = Constants;

const emailRegex = new RegExp(email_regex);

const CONTACT_CARD_MODES = {
    AUTOCOMPLETE: 'autocomplete',
    EDIT: 'edit',
    LOCKED: 'locked',
};

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function getReservationPageState() {
    let { always_on_guest_mode } = ProfileStore.getProfile();
    let private_travel = SearchStore.isPrivateTravel();
    return {
        profile: ProfileStore.getProfile(),
        agent_contract_id: SearchStore.getContractId(),
        agent_client_company_id: SearchStore.getContractClientCompanyId(),
        always_on_guest_mode: private_travel ? true : always_on_guest_mode,
        validFirstName: true,
        validLastName: true,
        validEmail: true,
        validPhone: true,
        ffnValidationStatus: null, // null | 'validating' | 'valid' | 'invalid'
        ffnValidationMessage: '',
        validationEnabled: false,
        private_travel,
        lastNameErrorMessage: undefined,
        firstNameErrorMessage: undefined,
    };
}

function isPrivateTravel() {
    return SearchStore.isPrivateTravel();
}

function isAutocompleteEnabled() {
    let profile = ProfileStore.getProfile();
    let private_travel = SearchStore.isPrivateTravel();
    if (private_travel) {
        return false;
    }
    if (profile) {
        if (profile.private_travel) {
            return false;
        }

        if (profile.agent && profile.company.id === SearchStore.getContractClientCompanyId()) {
            return false;
        }

        if (profile.always_on_guest_mode) {
            return false;
        }
    }

    return true;
}

class ContactCardLight extends React.Component {
    constructor(props) {
        super(props);

        const state = getReservationPageState();
        state.shouldCreateUser = true;

        const { reservation, contactIndex } = props;

        this.initializeTravelerFormState(state, reservation, contactIndex);

        if (isPrivateTravel()) {
            state.mode = CONTACT_CARD_MODES.EDIT;
            state.shouldCreateUser = false;
        } else if (!isAutocompleteEnabled()) {
            state.mode = CONTACT_CARD_MODES.EDIT;
            state.shouldCreateUser = false;
        } else {
            state.mode = CONTACT_CARD_MODES.AUTOCOMPLETE;
            state.failed = false;
        }

        state.search_text = '';

        this.state = state;

        this.saveCardDebounced = _.debounce(this.saveCard, 500);

        let bind_functions = [
            'validateTravelerDetails',
            'saveCard',
            'removeCard',
            'onFirstNameChanged',
            'onLastNameChanged',
            'onEmailChanged',
            'onPhoneChanged',
            'onFFNChanged',
            'handleVerifyMatmid',
            'handleSaveOnBlur',
            'handleNameBlur',
            'verifyMatmidIfChanged',
            'getMockTraveler',
            'fillCardCheat',
            'updateTraveler',
            'onTravelerAutoCompleteBlur',
            'onTravelerAutoCompleteUpdateInput',
            'onTravelerAutoCompleteNewRequest',
            'createTraveler',
            'shouldDisplayRemoveButton',
            'shouldDisplayEmailError',
            'setEnglishCharsMessage',
            'updateTravelerIfNeeded',
            'initializeTravelerFormState',
            'editCard',
            'handleClearDetails',
            'saveCardDebounced',
            'scrollToFFNField',
        ];

        for (let f of bind_functions) {
            this[f] = this[f].bind(this);
        }

        Events.on(SAVE_TRAVELER_CARD, this.saveCard);

        this.lastValidatedFirstName = '';
        this.lastValidatedLastName = '';
        this.lastValidatedFFN = '';

        this.ffnInputRef = React.createRef();

        this.displayName = 'ContactCardLight';
    }

    static getDerivedStateFromProps(nextProps, nextState) {
        const create_status = nextProps.createTravelerStatus;

        let derived_state = {
            busy: create_status === ReservationConstants.STATUS.BUSY,
            failed: create_status === ReservationConstants.STATUS.FAILED,
            created_traveler: create_status === ReservationConstants.STATUS.SUCCESS,
        };

        const valid = TravelersHelper.isValidTraveler(
            nextProps.reservation.travelers[nextProps.contactIndex],
            nextProps.isElal,
        );

        if (
            nextProps.reservation.travelers[nextProps.contactIndex]?.id &&
            valid &&
            !isPrivateTravel() &&
            !nextProps.diableTravellersDialog
        ) {
            derived_state.mode = CONTACT_CARD_MODES.LOCKED;
        }

        return derived_state;
    }

    componentDidMount() {
        // Check if FFN was autofilled and trigger validation
        const { traveler } = this.state;
        const points = PointsStore.getPoints();
        const memberNumber = points?.member_number;
        if (
            this.props.isElal &&
            this.props.contactIndex === 0 &&
            this.props.diableTravellersDialog &&
            memberNumber &&
            traveler.frequent_flyer_number === memberNumber.toString() &&
            traveler.first_name &&
            traveler.last_name
        ) {
            // Trigger validation for autofilled FFN
            this.verifyMatmidIfChanged();
        }
    }

    componentWillUnmount() {
        Events.removeEventListener(SAVE_TRAVELER_CARD, this.saveCard);
    }

    componentDidUpdate(prevProps, prevState) {
        // console.info('------------------------------------');
        // console.info('CCL did update...');
        // console.info('=============================================');

        let state = {};
        if (
            (!prevState.busy || !this.state.failed) &&
            ((prevState.busy && this.state.created_traveler) || (!prevState.created_guest && this.state.created_guest))
        ) {
            if (!this.props.diableTravellersDialog) {
                state.mode = CONTACT_CARD_MODES.LOCKED;
            }
            state.failed = false;
        }

        if (prevState.mode === CONTACT_CARD_MODES.AUTOCOMPLETE && this.state.mode === CONTACT_CARD_MODES.EDIT) {
            state.showEnglishCharsMessage = false;
            state.validFirstName = true;
            state.validLastName = true;
            state.validEmail = true;
            state.validPhone = true;
            state.traveler = this.state.traveler;
            let text = this.state.search_text || '';
            if (Validator.validateEmailAddress(text)) {
                state.traveler.email = text;
            } else {
                let split_name = this.state.search_text
                    .split(' ')
                    .map((s) => s.trim())
                    .filter((s) => s);
                if (split_name.length) {
                    state.traveler.first_name = Validator.filterEnglishOnly(split_name[0]);
                    state.traveler.last_name = Validator.filterEnglishOnly(split_name.slice(1).join(' '));
                }
            }
        }

        if (Object.keys(state).length) {
            this.setState(state);
        }

        if (this.props.autoFill && !this.state.did_auto_fill) {
            const _self = this;
            setTimeout(() => {
                _self.fillCardCheat();
                _self.setState({ did_auto_fill: true });
            }, 1);
        }
    }

    initializeTravelerFormState(state, reservation, contactIndex) {
        const profile = ProfileStore.getProfile();

        state.traveler = reservation?.travelers?.[contactIndex] || {};
        const mainTraveler = contactIndex === 0;

        // used for instance in HTZ integration to avoid any data to be prefilled
        const disable_travelers_data_prefill = _.get(
            profile,
            'company.partners_ui.disable_travelers_data_prefill',
            false,
        );
        state.avatarPrefilled = !disable_travelers_data_prefill;

        const prefill_with_external_travelers = _.get(
            profile,
            'company.partners_ui.prefill_with_external_travelers',
            false,
        );

        const mandatory_use_profile_email = _.get(profile, 'company.partners_ui.mandatory_use_profile_email', false);
        state.mandatoryUseProfileEmail = mandatory_use_profile_email;

        // prefill the form with external travelers, e.g. for RN
        if (prefill_with_external_travelers && profile.travelers?.length && mainTraveler) {
            state.traveler = profile.travelers[contactIndex] || {};
            if (mandatory_use_profile_email || !Validator.validateEmailAddress(state.traveler.email)) {
                state.traveler.email = profile.email ?? '';
            }
        } else if (
            isPrivateTravel() &&
            mainTraveler &&
            (!disable_travelers_data_prefill || mandatory_use_profile_email)
        ) {
            state.traveler.first_name = profile.first_name ?? '';
            state.traveler.last_name = profile.last_name ?? '';

            if (profile.first_name && profile.last_name) {
                state.traveler.email = profile.email ?? '';
                state.traveler.phone = profile.tel ?? '';
                if (this.props.diableTravellersDialog) {
                    state.traveler.full_name = `${profile.first_name} ${profile.last_name}`;
                    state.avatarPrefilled = true;
                }
            }
        }

        // Autofill Frequent Flyer Number for ELAL main guest
        state.traveler = this.checkAndAutofillFFN(state.traveler);
    }

    validateTravelerDetails(traveler) {
        const { mainGuest, isLeadTraveller, isElal } = this.props;
        const { validFirstName, validLastName, validEmail, validPhone } = TravelersHelper.getValidationResults(
            traveler,
            mainGuest,
            isElal,
        );

        let validFFNVerification = true;
        if (isLeadTraveller && isElal && traveler.frequent_flyer_number) {
            validFFNVerification = traveler.isFFNVerificationPassed === true;
            if (!validFFNVerification) {
                this.scrollToFFNField();
            }
        }

        this.setState({
            validFirstName,
            validLastName,
            validEmail,
            validPhone: mainGuest ? validPhone : true,
        });

        return validFirstName && validLastName && validEmail && (mainGuest ? validPhone : true) && validFFNVerification;
    }

    updateTravelerIfNeeded(traveler, travelers) {
        const { contactIndex } = this.props;
        const original = traveler.last_name;
        const filterTraveler = ({ full_name }, index) => full_name === traveler.full_name && index !== contactIndex;
        let i = -1;
        while (travelers.filter(filterTraveler).length) {
            i++;
            traveler.last_name = `${original} ${LETTERS[i]}`;
            traveler.ghost = true;
            traveler = TravelersHelper.updateTravelerFullName(traveler);
        }
    }

    saveCard() {
        this.setState({
            validationEnabled: true,
        });
        let { roomNumber, contactIndex, reservation, diableTravellersDialog } = this.props;
        let { mode, traveler, shouldCreateUser } = this.state;

        if (diableTravellersDialog) {
            if (traveler.id) {
                traveler.shouldCreateUser = false;
            } else {
                traveler.shouldCreateUser = shouldCreateUser;
            }

            const reservationTraveler = reservation.travelers[contactIndex];
            if (reservationTraveler) {
                ReservationActions.updateTraveler(contactIndex, traveler);
            } else {
                ReservationActions.addGuestTraveler(contactIndex, traveler, roomNumber);
            }

            if (this.validateTravelerDetails(traveler)) {
                this.updateTravelerIfNeeded(traveler, reservation.travelers);

                this.setState({
                    failed: false,
                    created_guest: true,
                    avatarPrefilled: true,
                });

                ReservationActions.removeTravelerError(roomNumber, contactIndex);
            } else {
                this.setState({
                    failed: true,
                    created_guest: true,
                    avatarPrefilled: false,
                });

                ReservationActions.addTravelerError(roomNumber, contactIndex);
            }

            return;
        }

        if (mode === CONTACT_CARD_MODES.LOCKED) {
            ReservationActions.removeTravelerError(roomNumber, contactIndex);
        } else {
            if (this.validateTravelerDetails(traveler)) {
                this.updateTravelerIfNeeded(traveler, reservation.travelers);
                traveler.shouldCreateUser = shouldCreateUser;
                ReservationActions.addGuestTraveler(contactIndex, traveler, roomNumber);

                this.setState({
                    mode: CONTACT_CARD_MODES.LOCKED,
                    failed: false,
                    created_guest: true,
                    avatarPrefilled: true,
                });

                ReservationActions.removeTravelerError(roomNumber, contactIndex);
            } else {
                ReservationActions.addTravelerError(roomNumber, contactIndex);
            }
        }
    }

    removeCard(e) {
        let { reservation, contactIndex } = this.props;
        let { mode, mandatoryUseProfileEmail } = this.state;

        let traveler = Object.assign(
            {},
            mode === CONTACT_CARD_MODES.LOCKED ? reservation.travelers[contactIndex] : new User(this.state.traveler),
        );

        ReservationActions.resetTraveler(contactIndex);

        this.setState({
            mode: isAutocompleteEnabled() ? CONTACT_CARD_MODES.AUTOCOMPLETE : CONTACT_CARD_MODES.EDIT,
            traveler: {
                full_name: '',
                first_name: '',
                last_name: '',
                email: mandatoryUseProfileEmail && contactIndex === 0 ? this.state.traveler.email : '',
                phone: '',
                shouldCreateUser: this.state.shouldCreateUser,
            },
            search_text: '',
            showEnglishCharsMessage: false,
            validFirstName: true,
            validLastName: true,
            validEmail: true,
            validPhone: true,
            validationEnabled: false,
            failed: false,
            busy: false,
            created_traveler: false,
            created_guest: false,
        });

        Analytics.removedTraveler(reservation.id, traveler.first_name, traveler.last_name, traveler.email);
    }

    editCard(e) {
        const { reservation, contactIndex } = this.props;
        const { mode } = this.state;

        let traveler = Object.assign(
            {},
            mode === CONTACT_CARD_MODES.LOCKED ? reservation.travelers[contactIndex] : new User(this.state.traveler),
        );

        ReservationActions.resetTraveler(contactIndex);

        this.setState((prevState) => ({
            ...prevState,
            traveler: {
                full_name: traveler?.fullName || '',
                first_name: traveler?.first_name || '',
                last_name: traveler?.last_name || '',
                email: traveler?.email || '',
                phone: traveler?.phone || '',
                shouldCreateUser: this.state.shouldCreateUser,
            },
            search_text: traveler?.first_name || prevState.searchText,
            mode: isAutocompleteEnabled() ? CONTACT_CARD_MODES.AUTOCOMPLETE : CONTACT_CARD_MODES.EDIT,
            showEnglishCharsMessage: false,
            validFirstName: true,
            validLastName: true,
            validEmail: true,
            validPhone: true,
            validationEnabled: false,
            failed: false,
            busy: false,
            created_traveler: false,
            created_guest: false,
        }));
    }

    scrollToFFNField() {
        if (this.ffnInputRef && this.ffnInputRef.current) {
            setTimeout(() => {
                this.ffnInputRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
                this.ffnInputRef.current.focus();
            }, 300);
        }
    }

    handleClearDetails(e) {
        const { contactIndex } = this.props;

        ReservationActions.resetTraveler(contactIndex);

        this.setState(
            {
                mode: isAutocompleteEnabled() ? CONTACT_CARD_MODES.AUTOCOMPLETE : CONTACT_CARD_MODES.EDIT,
                traveler: {
                    full_name: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    phone: '',
                    frequent_flyer_number: '',
                    shouldCreateUser: this.state.shouldCreateUser,
                    isFFNValid: true,
                },
                search_text: '',
                showEnglishCharsMessage: false,
                validFirstName: true,
                validLastName: true,
                validEmail: true,
                validPhone: true,
                validationEnabled: false,
                failed: false,
                busy: false,
                created_traveler: false,
                created_guest: false,
                ffnValidationStatus: null,
                ffnValidationMessage: '',
            },
            () => {
                this.handleSaveOnBlur();
            },
        );
    }

    getNameValidationResult(rawName) {
        if (!rawName) {
            return {
                isValid: true,
                errorMessage: undefined,
            };
        }

        const isValid = this.props.isElal
            ? Validator.validateClearEnglishOnly(rawName.trim())
            : Validator.validateEnglishOnly(rawName.trim());
        const errorMessage = (() => {
            if (!this.props.isElal) {
                return undefined;
            }

            return isValid ? undefined : this.props.t('ForbiddenCharsMessage');
        })();

        return {
            isValid,
            errorMessage,
        };
    }

    checkAndAutofillFFN(traveler) {
        const { contactIndex, isElal } = this.props;
        const mainTraveler = contactIndex === 0;
        const profile = ProfileStore.getProfile();
        const points = PointsStore.getPoints();
        const memberNumber = points?.member_number;

        if (
            isElal &&
            mainTraveler &&
            memberNumber &&
            traveler.first_name &&
            traveler.last_name &&
            !traveler.frequent_flyer_number
        ) {
            const profileFirstName = (profile.first_name || '').toLowerCase().trim();
            const profileLastName = (profile.last_name || '').toLowerCase().trim();
            const travelerFirstName = (traveler.first_name || '').toLowerCase().trim();
            const travelerLastName = (traveler.last_name || '').toLowerCase().trim();

            if (profileFirstName === travelerFirstName && profileLastName === travelerLastName) {
                traveler.frequent_flyer_number = memberNumber.toString();
            }
        }

        return traveler;
    }

    onFirstNameChanged(e) {
        const rawName = e.target.value;
        let name = this.props.isElal ? TravelersHelper.getValidNameExcludingForbiddenChars(rawName) : rawName;
        let traveler = Object.assign({}, this.state.traveler);
        traveler.first_name = name;
        traveler = TravelersHelper.updateTravelerFullName(traveler);
        const { validationEnabled } = this.state;
        const validationResult = this.getNameValidationResult(rawName);
        const shouldShowValidation = validationEnabled || (this.props.isElal && !validationResult.isValid);

        this.setState({
            traveler,
            ...(shouldShowValidation
                ? {
                      validFirstName: validationResult.isValid,
                      firstNameErrorMessage: validationResult.errorMessage,
                  }
                : {}),
        });
    }

    onLastNameChanged(e) {
        const rawName = e.target.value;
        let name = this.props.isElal ? TravelersHelper.getValidNameExcludingForbiddenChars(rawName) : rawName;
        let traveler = Object.assign({}, this.state.traveler);
        traveler.last_name = name;
        traveler = TravelersHelper.updateTravelerFullName(traveler);
        const { validationEnabled } = this.state;
        const validationResult = this.getNameValidationResult(rawName);
        const shouldShowValidation = validationEnabled || (this.props.isElal && !validationResult.isValid);

        this.setState({
            traveler,
            ...(shouldShowValidation
                ? {
                      validLastName: validationResult.isValid,
                      lastNameErrorMessage: validationResult.errorMessage,
                  }
                : {}),
        });
    }

    onEmailChanged(e) {
        let traveler = Object.assign({}, this.state.traveler);
        traveler.email = e.target.value && e.target.value.trim();
        const { validationEnabled } = this.state;
        this.setState({
            traveler,
            ...(validationEnabled
                ? { validEmail: !traveler.email || Validator.validateEmailAddress(traveler.email) }
                : {}),
        });
    }

    onPhoneChanged(e) {
        const phoneValue = e.target ? e.target.value : e;
        const traveler = { ...this.state.traveler };
        traveler.phone = phoneValue;
        const { validationEnabled } = this.state;

        this.setState({
            traveler,
            ...(validationEnabled ? { validPhone: Validator.validatePhoneNumber(phoneValue) } : {}),
        });
    }

    onFFNChanged(e) {
        let traveler = { ...this.state.traveler };
        traveler.frequent_flyer_number = e.target.value;
        traveler.isFFNValid = true;
        traveler.isFFNVerificationPassed = false;

        this.setState({
            traveler,
            ffnValidationStatus: null,
            ffnValidationMessage: '',
        });

        this.saveCardDebounced();
    }

    async handleVerifyMatmid(updatedTraveler = {}) {
        const traveler = { ...this.state.traveler, ...updatedTraveler };
        const ffn = traveler.frequent_flyer_number?.trim();
        const { t } = this.props;

        if (!ffn) {
            return;
        }

        if (!TravelersHelper.getValidFFN(ffn)) {
            this.setState({
                ffnValidationStatus: 'invalid',
                ffnValidationMessage: t('FFNInvalidFormatMessage'),
                traveler: { ...traveler, isFFNValid: false },
            });
            return;
        }

        if (!traveler.first_name || !traveler.last_name) {
            return;
        }

        this.setState({ ffnValidationStatus: 'validating' });

        try {
            const result = await Ajax.validateFrequentFlyerMember(traveler.first_name, traveler.last_name, ffn);

            if (result.success) {
                this.setState({
                    ffnValidationStatus: 'valid',
                    ffnValidationMessage: '',
                    traveler: {
                        ...this.state.traveler,
                        isFFNValid: true,
                        isFFNVerificationPassed: true,
                    },
                });
            } else {
                this.setState({
                    ffnValidationStatus: 'invalid',
                    ffnValidationMessage: result.error || t('FFNDetailsDoNotMatch'),
                    traveler: {
                        ...this.state.traveler,
                        isFFNValid: false,
                        isFFNVerificationPassed: false,
                    },
                });
            }
        } catch (error) {
            this.setState({
                ffnValidationStatus: 'invalid',
                ffnValidationMessage: t('FFNValidationError'),
                traveler: {
                    ...this.state.traveler,
                    isFFNValid: false,
                },
            });
        }
        this.handleSaveOnBlur();
    }

    handleSaveOnBlur() {
        if (!this.props.diableTravellersDialog) {
            return;
        }

        setTimeout(() => {
            this.saveCard();
        }, 0);
    }

    verifyMatmidIfChanged(traveler = {}) {
        const { first_name, last_name, frequent_flyer_number } = { ...this.state.traveler, ...traveler };
        const hasChanged =
            first_name !== this.lastValidatedFirstName ||
            last_name !== this.lastValidatedLastName ||
            frequent_flyer_number !== this.lastValidatedFFN;

        if (hasChanged) {
            this.lastValidatedFirstName = first_name;
            this.lastValidatedLastName = last_name;
            this.lastValidatedFFN = frequent_flyer_number;
            this.handleVerifyMatmid();
        }
    }

    handleNameBlur(e, isFirstName) {
        if (!this.props.diableTravellersDialog || !this.props.isElal) {
            return;
        }
        const { validationEnabled } = this.state;
        const rawValue = e.target.value;
        const newValue = TravelersHelper.getValidNameExcludingForbiddenChars(rawValue);
        const hasError = isFirstName ? this.state.firstNameErrorMessage : this.state.lastNameErrorMessage;
        const shouldClearValidation = validationEnabled || hasError;

        this.setState({
            ...(shouldClearValidation
                ? {
                      [`valid${isFirstName ? 'First' : 'Last'}Name`]: true,
                      [`${isFirstName ? 'first' : 'last'}NameErrorMessage`]: undefined,
                      traveler: {
                          ...this.state.traveler,
                          [`${isFirstName ? 'first' : 'last'}_name`]: newValue,
                      },
                  }
                : {}),
        });

        this.handleSaveOnBlur();
        this.verifyMatmidIfChanged(isFirstName ? { first_name: newValue } : { last_name: newValue });
    }

    getMockTraveler() {
        switch (this.props.contactIndex) {
            case 0:
                return 'Gustav Silver';

            case 1:
                return 'Lillian Silver';

            case 2:
                return 'Gustav Mercury';

            case 3:
                return 'Lillian Mercury';

            default:
                return 'Gustav Silver';
        }
    }

    fillCardCheat() {
        const { mainGuest } = this.props;

        const full_name = this.getMockTraveler();
        const [first_name, last_name] = full_name.split(' ');

        const traveler = Object.assign({}, this.state.traveler, {
            first_name,
            last_name,
            full_name,
            shouldCreateUser: false,
            id: undefined,
            email: undefined,
        });

        if (mainGuest) {
            traveler.first_name = first_name;
            traveler.last_name = last_name;
            traveler.email = `${first_name.toLowerCase()}.${last_name.toLowerCase()}@example.com`;
            traveler.phone = '+1234567890';
            traveler.id = undefined;
            traveler.email = '';
        }

        if (this.validateTravelerDetails(traveler)) {
            ReservationActions.addGuestTraveler(this.props.contactIndex, traveler, this.props.roomNumber);
            const stateUpdate = {
                traveler,
                failed: false,
                created_guest: true,
            };
            if (this.props.diableTravellersDialog) {
                stateUpdate.search_text = traveler.first_name;
                this.verifyMatmidIfChanged(traveler);
            } else {
                stateUpdate.mode = CONTACT_CARD_MODES.LOCKED;
            }
            this.setState(stateUpdate);
        }
    }

    updateTraveler(profile) {
        ReservationActions.updateTraveler(
            this.props.contactIndex,
            new User(
                Object.assign(profile, {
                    room: this.props.roomNumber,
                }),
            ),
        );
    }

    onTravelerAutoCompleteBlur() {
        this.setState({
            validFirstName: true,
            validLastName: true,
            validEmail: true,
            validPhone: true,
        });

        if (this.props.diableTravellersDialog) {
            this.verifyMatmidIfChanged();
        }
    }

    onTravelerAutoCompleteUpdateInput(searchText) {
        let traveler = Object.assign({}, this.state.traveler);
        const name = this.props.isElal ? TravelersHelper.getValidNameExcludingForbiddenChars(searchText) : searchText;
        traveler.first_name = name;

        if (this.props.diableTravellersDialog) {
            traveler.id = undefined;
        }

        traveler = TravelersHelper.updateTravelerFullName(traveler);
        const { validationEnabled } = this.state;
        const validationResult = this.getNameValidationResult(searchText);
        const shouldShowValidation = validationEnabled || (this.props.isElal && !validationResult.isValid);

        this.setState({
            traveler,
            search_text: name,
            ...(shouldShowValidation
                ? {
                      validFirstName: validationResult.isValid,
                      firstNameErrorMessage: validationResult.errorMessage,
                  }
                : {}),
        });
    }

    setEnglishCharsMessage(validated) {
        this.setState({ showEnglishCharsMessage: validated });
    }

    onTravelerAutoCompleteNewRequest(data) {
        if (!data) {
            return;
        }

        if (data.id !== -1) {
            this.updateTraveler(data);

            ReservationActions.removeTravelerError(this.props.roomNumber, this.props.contactIndex);
        }

        let state = {
            validFirstName: true,
            validLastName: true,
            validEmail: true,
            validPhone: true,
        };

        if (data.id === -1) {
            state.mode = CONTACT_CARD_MODES.EDIT;
        } else if (data.id) {
            if (this.props.diableTravellersDialog) {
                state.traveler = {
                    id: data.id,
                    first_name: data.first_name || '',
                    last_name: data.last_name || '',
                    email: data.email || '',
                    phone: data.phone || '',
                    full_name: data.full_name || '',
                    frequent_flyer_number: this.state.traveler.frequent_flyer_number || '',
                };
            } else {
                state.mode = CONTACT_CARD_MODES.LOCKED;
            }
            state.failed = false;

            let reservation = this.props.reservation;
            let traveler = new User(data);

            Analytics.pickedTravelerFromAutocomplete(
                this.state.profile.company,
                reservation.id,
                traveler.first_name,
                traveler.last_name,
                traveler.email,
            );
        } else {
            return;
        }

        this.setState(state);

        this.props.diableTravellersDialog && state.traveler && this.verifyMatmidIfChanged(state.traveler);
    }

    createTraveler() {
        this.setState({
            validFirstName: true,
            validLastName: true,
            validEmail: true,
            validPhone: true,
            mode: CONTACT_CARD_MODES.EDIT,
        });
    }

    shouldDisplayRemoveButton() {
        let { mode } = this.state;
        const { diableTravellersDialog } = this.props;

        if (diableTravellersDialog) {
            return false;
        }

        if (mode === CONTACT_CARD_MODES.AUTOCOMPLETE) {
            return false;
        }

        return !(mode === CONTACT_CARD_MODES.EDIT && !isAutocompleteEnabled());
    }

    shouldDisplayEmailError() {
        const { validEmail, traveler } = this.state;
        const valid_email = emailRegex.test(traveler.email);

        if (validEmail) {
            return false;
        }

        return !(!traveler.email || valid_email);
    }

	renderPhoneInput() {
		const { traveler, validPhone, busy, profile } = this.state;
		const { contactIndex, i18n } = this.props;
		const show_country_code_phone = _.get(profile, 'company.partners_ui.show_country_code_phone', false);

		const commonProps = {
			className: classNames('field-input phone', { error: !validPhone }),
			value: traveler.phone,
			onChange: this.onPhoneChanged,
			onBlur: this.handleSaveOnBlur,
			fullWidth: true,
			disabled: busy || this.props.disabled,
			inputProps: { dir: i18n.language === SUPPORTED_LANGUAGES.HE && RTL}
		};

        return (
            <div style={{ position: 'relative' }}>
                {show_country_code_phone ? (
                    <MuiTelInput {...commonProps} defaultCountry="US" id={`phone-number-input-${contactIndex}`} />
                ) : (
                    <TextField {...commonProps} type="tel" id={`phone-number-input-${contactIndex}`} />
                )}
                {show_country_code_phone && <div className="caret-down"></div>}
            </div>
        );
    }

    renderAvatar(reservation_traveler) {
        const { avatarPrefilled, traveler } = this.state;
        const { diableTravellersDialog } = this.props;
        const showAvatar = avatarPrefilled || this.state.mode === CONTACT_CARD_MODES.LOCKED;

        const fullName = showAvatar
            ? reservation_traveler.full_name || (diableTravellersDialog && traveler?.full_name) || ''
            : '';

        return (
            <Avatar
                className="avatar"
                {...avatarProps({
                    fullName,
                    url: reservation_traveler.picture,
                })}
                onDoubleClick={Config.dev_mode ? this.fillCardCheat : null}
            />
        );
    }

    pushEditableFields(details) {
        let { contactIndex, mainGuest, t, isLeadTraveller, isElal, i18n } = this.props;
        let {
            mode,
            busy,
            search_text,
            traveler,
            validFirstName,
            validLastName,
            validEmail,
            showEnglishCharsMessage,
            mandatoryUseProfileEmail,
            firstNameErrorMessage,
            lastNameErrorMessage,
        } = this.state;

        if (!traveler) {
            traveler = {};
        }

        let autocomplete_mode = mode === CONTACT_CARD_MODES.AUTOCOMPLETE;

        let reservation_traveler = this.props.reservation.travelers[contactIndex];

        if (!reservation_traveler) {
            return;
        }

        details.push(
            autocomplete_mode ? (
                <div className={'card-name-input' + (traveler.first_name ? ' has-value' : '')} key="first-name-key">
                    <label htmlFor={`first-name-input-${contactIndex}`}>{t('Contacts.FirstName')}</label>
                    <TravelersAutocomplete
                        id={`first-name-input-${contactIndex}`}
                        key="autocomplete-key"
                        onClose={this.onTravelerAutoCompleteBlur}
                        fullWidth
                        disabled={busy}
                        searchText={search_text}
                        onNewRequest={this.onTravelerAutoCompleteNewRequest}
                        onUpdateInput={this.onTravelerAutoCompleteUpdateInput}
                        setEnglishChParsMessage={this.setEnglishCharsMessage}
                        error={!validFirstName}
                        agent_contract_id={this.state.agent_contract_id}
                        agent_client_company_id={this.state.agent_client_company_id}
                        dataTestId="traveler-first-name-input"
                        onBlur={(e) => this.handleNameBlur(e, true)}
                    />
                    {!isElal && showEnglishCharsMessage && (
                        <span className="invalid-traveler" key="invalid-traveler-3">
                            {t('PleaseMakeSureYouTypeInEnglish')}
                        </span>
                    )}
                    {isElal && firstNameErrorMessage && (
                        <div className="error-message">
                            <span>{firstNameErrorMessage}</span>
                        </div>
                    )}
                </div>
            ) : (
                <div className={'card-name-input' + (traveler.first_name ? ' has-value' : '')} key="first-name-key">
                    <label htmlFor={`first-name-input-${contactIndex}`}>{t('Contacts.FirstName')}</label>
                    <TextField
                        id={`first-name-input-${contactIndex}`}
                        className={classNames('field-input', !validFirstName && 'error')}
                        disabled={busy || this.props.disabled}
                        fullWidth
                        value={traveler.first_name}
                        onChange={this.onFirstNameChanged}
                        onBlur={(e) => this.handleNameBlur(e, true)}
                        inputProps={{
                            'data-testid': 'traveler-first-name-input',
                        }}
                    />
                    {isElal && firstNameErrorMessage && (
                        <div className="error-message">
                            <span>{firstNameErrorMessage}</span>
                        </div>
                    )}
                </div>
            ),
        );

        details.push(
            <div className={'card-name-input' + (traveler.last_name ? ' has-value' : '')} key="last-name-key">
                <label htmlFor={`last-name-input-${contactIndex}`}>{t('Contacts.LastName')}</label>
                <TextField
                    id={`last-name-input-${contactIndex}`}
                    className={classNames('field-input', !validLastName && 'error')}
                    disabled={busy || this.props.disabled}
                    fullWidth
                    value={traveler.last_name}
                    onChange={this.onLastNameChanged}
                    onBlur={(e) => this.handleNameBlur(e, false)}
                    inputProps={{
                        'data-testid': 'traveler-last-name-input',
                    }}
                />
                {isElal && lastNameErrorMessage && (
                    <div className="error-message">
                        <span>{lastNameErrorMessage}</span>
                    </div>
                )}
            </div>,
        );

		details.push(
				<div
					className={'card-input traveler-email-input' + (traveler.email ? ' has-value' : '')}
					key="email-key"
				>
					<label htmlFor={`email-input-${contactIndex}`}>
						{mainGuest ? t('Contacts.Email') : t('Contacts.EmailOptional')}
					</label>
					<TextField
						id={`email-input-${contactIndex}`}
						className={classNames(
							'field-input',
							(!validEmail || this.shouldDisplayEmailError()) && 'error',
						)}
						disabled={busy || (mainGuest && mandatoryUseProfileEmail) || this.props.disabled}
						fullWidth
						value={traveler.email}
						onChange={this.onEmailChanged}
						onBlur={this.handleSaveOnBlur}
					/>
				</div>,
		);
		if (mainGuest) {
			details.push(
					<div
						className={'card-input traveler-phone-input' + (traveler.phone ? ' has-value' : '')}
						key="phone-key"
					>
						<label htmlFor={`phone-number-input-${contactIndex}`}>{t('Contacts.PhoneNumber')}</label>
						{this.renderPhoneInput()}
					</div>,
			);
		}
		
		if (isLeadTraveller && isElal) {
				details.push(
						<div
							className={classNames('card-input traveler-ffn-input', {
								'has-value': traveler.frequent_flyer_number
							})}
							key="ffn-key"
						>
							<label htmlFor={`ffn-input-${contactIndex}`}>{t('FrequentFlyerNumber')}</label>
							<div className='traveler-ffn-input-wrap'>
								<TextField
									id={`ffn-input-${contactIndex}`}
									className={classNames('field-input', this.state.traveler.isFFNValid === false && 'error')}
									disabled={busy || this.state.ffnValidationStatus === 'validating' || this.props.disabled}
									fullWidth
									value={traveler.frequent_flyer_number || ''}
									onChange={this.onFFNChanged}
									placeholder={t('Contacts.FFNPlaceholder')}
									inputRef={this.ffnInputRef}
									inputProps={{
										maxLength: 9,
										pattern: '[0-9]*',
										inputMode: 'numeric',
									}}
									onBlur={(e) => {
										this.verifyMatmidIfChanged({ frequent_flyer_number: e.target.value });
									}}
									InputProps={{
										endAdornment: <>
											{this.state.ffnValidationStatus === 'validating' && (
												<CircularProgress size={20} className={classNames('ffn-validation-icon', 'validating', { 'ffn-rtl': i18n.language === 'he' })} />
											)}
											{this.state.ffnValidationStatus === 'valid' && (
												<CheckCircleIcon className={classNames('ffn-validation-icon', 'valid', { 'ffn-rtl': i18n.language === 'he' })} />
											)}
											{this.state.ffnValidationStatus === 'invalid' && (
												<ErrorOutlineIcon className={classNames('ffn-validation-icon', 'invalid', { 'ffn-rtl': i18n.language === 'he' })} />
											)}
										</>
										}}
									/>
							</div>

							{this.state.ffnValidationMessage && (
								<div className="card-alert invalid-ffn">
									<span>{this.state.ffnValidationMessage}</span>
								</div>
							)}
						</div>
				);
		}
		if (isElal && mainGuest) {
			details.push(<PointsAndDiamondsBanner/>);
		}
	}

    render() {
        const DETAILS = [];

        let {
            disabled,
            contactIndex,
            travelerCountPerRoom,
            t,
            isElal,
            diableTravellersDialog,
            isLeadTraveller,
            i18n,
            mainGuest,
        } = this.props;
        let { mode, busy, traveler } = this.state;

        if (!traveler) {
            traveler = {};
        }

        let locked_mode = mode === CONTACT_CARD_MODES.LOCKED;

        let reservation_traveler = this.props.reservation.travelers[contactIndex];

        if (!reservation_traveler) {
            return null;
        }

        let email_exists = typeof reservation_traveler.email === 'string' && reservation_traveler.email.length;
        let phone_exists = reservation_traveler.phone.length;

        if (diableTravellersDialog) {
            this.pushEditableFields(DETAILS);
        } else {
            if (disabled || locked_mode) {
                DETAILS.push(
                    <div
                        className={'card-div traveler-name-div' + (email_exists ? '' : ' name-only')}
                        key="traveler-name-key"
                    >
                        <span title={reservation_traveler.full_name}>{reservation_traveler.full_name}</span>
                    </div>,
                );
                if (email_exists) {
                    DETAILS.push(
                        <div className="card-div traveler-email-div" key="traveler-email-key">
                            <span title={reservation_traveler.email}>{reservation_traveler.email}</span>
                        </div>,
                    );
                }
                if (phone_exists) {
                    DETAILS.push(
                        <div className="card-div traveler-phone-div" key="traveler-phone-key">
                            <span dir={LTR} title={reservation_traveler.phone}>
                                {reservation_traveler.phone}
                            </span>
                        </div>,
                    );
                }
            } else if (!locked_mode) {
                this.pushEditableFields(DETAILS);
            }
        }

        const ACTIONS = [];

        if (!locked_mode && !diableTravellersDialog) {
            ACTIONS.push(
                <div key={`${contactIndex}-button-container`} className="button-container">
                    <ArbiCancelButton
                        key={contactIndex + '-clear'}
                        onClick={busy ? _.noop : this.removeCard}
                        disabled={busy}
                        aria-label={`Clear traveler ${contactIndex + 1}`}
                    >
                        {t('Contacts.Clear')}
                    </ArbiCancelButton>
                    <LoadingButton
                        className="action-button add-button"
                        onClick={this.saveCard}
                        loading={busy}
                        disableRipple
                        aria-label={`Add traveler ${contactIndex + 1}`}
                        data-testid={`add-contact-${contactIndex}`}
                    >
                        {!busy && t('Contacts.Add')}
                    </LoadingButton>
                </div>,
            );
        }

        let contact_card_classes = 'contact-card';

        if (locked_mode && !diableTravellersDialog) {
            contact_card_classes += ' locked';
        }

        if (diableTravellersDialog) {
            contact_card_classes += ' diable-travellers-dialog';
        }
        if (busy || this.props.disabled){
            contact_card_classes+=' disabled'
        }
        return (
            <div className={contact_card_classes} data-testid="traveler-details-section">
                <div className="content-container">
                    <span className="card-title-wrap">
                        <p className="card-title">
                            {diableTravellersDialog ? t('Traveler') : t('TravelerDetails')}
                            {!diableTravellersDialog && ` ${travelerCountPerRoom}`}
                            {diableTravellersDialog && isElal && isLeadTraveller && (
                                <span
                                    className={classNames('matmid-points-message', {
                                        'matmid-points-message-rtl': i18n.language === 'he',
                                    })}
                                >
                                    {t('MatmidPointsMessage', { number: travelerCountPerRoom })}
                                </span>
                            )}
                        </p>

                        {diableTravellersDialog && (
                            <button className="clear-details-button" onClick={this.handleClearDetails}>
                                {t('Contacts.ClearDetails')}
                                <SyncIcon />
                            </button>
                        )}
                    </span>
                    <div className="user-container">
                        <div className="avatar-container">{this.renderAvatar(reservation_traveler)}</div>
                        <div>
                            <div className="contact-details">{DETAILS}</div>
                        </div>
                    </div>

					{ACTIONS.length > 0 && <div className="action-container">{ACTIONS}</div>}

                    {this.shouldDisplayRemoveButton() && (
                        <IconButton
                            onClick={busy ? _.noop : this.editCard}
                            disabled={busy || disabled}
                            aria-label={`Edit traveler ${contactIndex + 1}`}
                            size="small"
                            className="edit-traveler-button"
                        >
                            <EditIcon fontSize="inherit" />
                        </IconButton>
                    )}
                </div>
                {this.state.failed ? (
                    <div className="card-alert failed-to-add-traveler">
                        <span>
                            {t('FailedToAddTraveler')}{' '}
                            <a href={`mailto:${t('HelpEmail')}`} target="_blank" rel="noreferrer">
                                {t('ContactUs')}
                            </a>
                            .
                        </span>
                    </div>
                ) : null}
                {!this.state.failed && this.shouldDisplayEmailError() && (
                    <div className="card-alert invalid-email">
                        <span>{t('PleaseInsertAValidEmailAddress')}</span>
                        {!this.state.private_travel && (
                            <span>{t('NoWorryNoEmailWillBeSentToTravelersUnlessRequestedByYou')}</span>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

ContactCardLight.propTypes = {
    reservation: PropTypes.any,
    contactIndex: PropTypes.number,
    createTravelerStatus: PropTypes.string,
    roomNumber: PropTypes.number,
    disabled: PropTypes.bool,
    mainGuest: PropTypes.bool,
    isElal: PropTypes.bool,
    diableTravellersDialog: PropTypes.bool,
    isLeadTraveller: PropTypes.bool,
};

export default withTranslation()(ContactCardLight);
